
import nene from '../../../assets/nene.png';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Progress } from '../../../interfaces/progress';

const ProgressReportSpanish = () => {
    const {
        progress,
        stage,
        instance_name,
    } = useSelector((state:any) => state.milestones);
    const { loading } = useSelector((state:any) => state.ui)
    const [backUrl, setBackUrl] = useState("");
    const history = useHistory();


    useEffect(() => {
        setBackUrl(localStorage.getItem('@urihitos') || "");
    },[])

    const calculatePercentage = (total:number, completed:number) => {
        const calculate = (completed * 100) / total;
        return Number(calculate.toFixed(0))
    }

    return (
        <div className="page">
            <div className="container">

                <div className="row mt-5">
                    <div className="col-sm-12 text-center">
                        <div>
                            <img src={nene} alt="Imagen niño"
                            width="200" height="auto" />
                            <div className="report2-name-child">
                                <h2>{instance_name}</h2>
                            </div>
                        </div>
                        <div>
                            <h1>Reporte de hitos alcanzados</h1>
                        </div>
                    </div>
                </div>

                { loading  ? (
                    <div className="d-flex justify-content-center">
                        <div className="spinner-border text-primary" role="status"
                        style={{ width: "4rem", height: "4rem"}}>
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                ) : (
                    stage.name ? (
                        <div className="row mt-2">
                            <div className="col-sm-12 text-center my-3">
                                <img src={stage.image_url} alt={stage.name}
                                width="200" height="auto"/>
                                <p className="mt-2">{stage.name.toUpperCase()}</p>
                            </div>
                        </div>
                    ): (
                        <div className="alert alert-info mt-4 mb-4 text-center">No se encontraron datos</div>
                    )
                )}


                <div className="row mt-5">
                    <div className="col-sm-12">
                        <h3 className="text-center">Hitos completados por área</h3>
                    </div>
                </div>

                { loading ? (
                    <div className="d-flex justify-content-center">
                        <div className="spinner-border text-primary" role="status"
                        style={{ width: "4rem", height: "4rem"}}>
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                ) : (
                    progress.length > 0 ? (
                        <div className="row mt-4">
                            {progress.map((item: Progress) => (
                                <div className="col-sm-4 text-center"
                                key={item.area.id}>
                                    <div style={{width: 200, height:200, margin: '10px auto'}}>
                                        <CircularProgressbar value={calculatePercentage(item.area_total, item.completed)} text={`${calculatePercentage(item.area_total, item.completed)}%`} />
                                    </div>
                                    <h4 className="mt-3">{item.area.name}</h4>
                                    <img src={item.area.image_url} alt={item.area.name}
                                    className="mt-4 icon-report2"/>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="alert alert-info text-center mt-4">No se encontraron datos</div>
                    )
                )}


                <div className="row text-center mt-5">
                    <div className="col-sm-12 my-3">
                        { backUrl && (
                            <button className="btn btn-primary"
                            type="button"
                            onClick={() => history.push(backUrl)}
                            style={{width: "220px"}}>Editar</button>
                        )}
                        <button className="btn btn-primary"
                        type="button"
                        onClick={() => window.location.reload()}
                        style={{width: "220px"}}>Actualizar</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProgressReportSpanish
